import Service from './Service';

export default class AdminUserService extends Service {
    constructor() {
        super();
        this.baseURL = 'adminuser/';
    }


}